// Resolve the tenant slug from the subdomain for multi-tenant staff login routing.
// Returns null on the apex domain, reserved subdomains, and the single-host
// preview/localhost — in which case login stays global (backwards compatible).
const ROOT_DOMAIN = "vidyapeeth360.com";
const RESERVED = new Set(["www", "app", "api", "admin", "preview", "staging"]);

export function getTenantSlug() {
  if (typeof window === "undefined") return null;
  const host = (window.location.hostname || "").toLowerCase();
  const suffix = `.${ROOT_DOMAIN}`;
  if (host.endsWith(suffix)) {
    const sub = host.slice(0, -suffix.length);
    if (sub && !sub.includes(".") && !RESERVED.has(sub)) return sub;
  }
  return null;
}
